export default function ThongTinChungTab2({ data, formatNumber }) {
    return (<>
        <div className="form-body form-bordered-2 row-store">
            <div className="form-body form-bordered-2 row-store">
                <div className="row col-md-12 ">
                    <div className="col-md-4">
                        <div className="form-group last-1">
                            <div className="row" style={{ padding: "20px" }}>
                                <div className="col-md-6 color7-bold">Số hợp đồng</div>
                                <div className="col-md-6 color-do-bold  text-right">
                                    {formatNumber(data.HD_Total)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group last-1">
                            <div className="row" style={{ padding: "20px" }}>
                                <div className="col-md-7 color7-bold">Hợp đồng đóng</div>
                                <div className="col-md-5 color-do-bold  text-right">
                                    {formatNumber(data.HD_Clode)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group last-1">
                            <div className="row" style={{ padding: "20px" }}>
                                <div className="col-md-6 color7-bold">Hợp đồng mở</div>
                                <div className="col-md-6 color-xanh-bold  text-right">
                                    {formatNumber(data.HD_Open)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row col-md-12 ">
                    <div className="col-md-6">
                        <div className="form-group last-1">
                            <div className="row" style={{ padding: "20px" }}>
                                <div className="col-md-6 color7-bold">Tiền cho vay</div>
                                <div className="col-md-6 color-do-bold  text-right">
                                    {formatNumber(Math.round(data.TienChoVay))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group last-1">
                            <div className="row" style={{ padding: "20px" }}>
                                <div className="col-md-6 color7-bold">Lãi chưa thu dự kiến</div>
                                <div className="col-md-6 color-do-bold  text-right">
                                    {formatNumber(Math.round(data.LaiChuaThu))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row col-md-12 ">
                <div className="col-md-6">
                    <div className="form-group last-1">
                        <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-6 color7-bold">Lãi đã thu</div>
                            <div className="col-md-6 color-do-bold  text-right">
                                {formatNumber(Math.round(data.LaiDaThu))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group last-1">
                        <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-6 color7-bold">Tiền khách nợ</div>
                            <div className="col-md-6 color-xanh-bold  text-right">
                                {formatNumber(Math.round(data.TienKhachNo))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
};